import React from 'react';
import ContactForm from '../components/contactform';
import '../styles/contact.css';

function Contact() {
  return (
    <section className="contact-page">
      <div className="container contact-page-inner">
        <ContactForm />
      </div>
    </section>
  );
}

export default Contact;
